import React from 'react';
import SearchAndFilterBar, { TSearchAndFilterBarProps } from '~components/molecules/SearchAndFilterBar';
import { useAppSelector } from '~redux/hooks';
import { initialState as approvalInitialState } from '~redux/slices/approval';

import * as Styles from './_DiscountApprovalSearchAndFilterBarStyles.module.scss';
import { TransactionActionEnum, TransactionStatusEnum } from '~utils/enums';
import { TPendingDiscountApprovalListingFilters } from '~types/feat/approval';
import { useDispatch } from 'react-redux';
import combinedActions from '~redux/combinedActions';

const DiscountApprovalSearchAndFilterBar = () => {
    const dispatch = useDispatch();

    const filters = useAppSelector(state => state.approval.pendingDiscountListing.filters);
    const initialFilters = approvalInitialState.pendingDiscountListing.filters;
    const nodata = false;

    const handleSearchClick = () => dispatch(combinedActions.approvalGetPendingDiscountListingAttempt());

    const handleCancelClick = () => {
        dispatch(combinedActions.approvalSetPendingDiscountListingFilters(initialFilters));
        dispatch(combinedActions.approvalGetPendingDiscountListingAttempt());
    };

    const setFilters = (filter: TPendingDiscountApprovalListingFilters) => dispatch(combinedActions.approvalSetPendingDiscountListingFilters(filter));

    const fields: TSearchAndFilterBarProps['fields'] = [
        {
            label: 'Discount Code:',
            type: 'input' as const,
            inputParams: {
                value: filters.discountCode,
                setValue: (event) => setFilters({ ...filters, discountCode: event.target.value }),
                onKeyDown: (event) => { if (event.key === 'Enter') handleSearchClick(); },
                className: Styles.input,
            },
        },
        {
            label: 'Discount Name:',
            type: 'input' as const,
            inputParams: {
                value: filters.discountName,
                setValue: (event) => setFilters({ ...filters, discountName: event.target.value }),
                onKeyDown: (event) => { if (event.key === 'Enter') handleSearchClick(); },
                className: Styles.input,
            },
        },
        {
            label: 'Discount Type:',
            type: 'dropdown' as const,
            dropdownParams: {
                options: [
                    {
                        label: TransactionActionEnum[TransactionActionEnum['Bank Sell']],
                        value: TransactionActionEnum['Bank Sell'],
                    },
                    {
                        label: TransactionActionEnum[TransactionActionEnum['Bank Buy']],
                        value: TransactionActionEnum['Bank Buy'],
                    },
                ],
                value: filters.transactionType,
                setValue: (event: React.ChangeEvent<HTMLInputElement>) => setFilters({
                    ...filters,
                    transactionType: event.target.value,
                }),
                optionSelected: !!filters.transactionType,
                noOptionsMessage: 'No branch found',
                disabled: nodata,
            },
        },
    ];
    return (
        <SearchAndFilterBar
            fields={fields}
            searchOnClick={handleSearchClick}
            cancelOnClick={handleCancelClick}
            containerClassName={Styles['content-container']}
        />
    );
};

export default DiscountApprovalSearchAndFilterBar;
